import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import axiosInstance from "../../axiosInstance";
import AdminDashboardLayout from "../../components/AdminDashboardLayout/AdminDashboardLayout";

const HomePageStatistics = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  // const [iframeUrl, setIframeUrl] = useState("");

  // useEffect(() => {
  //   const fetchDashboard = async () => {
  //     try {
  //       const res = await axiosInstance.get("api/v1/lookups/dashboard");
  //       setIframeUrl(res.data.iframeUrl);
  //     } catch (error) {
  //       console.error("Error loading Metabase dashboard:", error);
  //     }
  //   };

  //   fetchDashboard();
  // }, []);

  const iframeUrl =
    "http://metabase.speakers.sa/public/dashboard/af07060c-3c85-4fce-8994-3d09ce4a85dd";

  return (
    <AdminDashboardLayout pageTitle="لوحة الإحصائيات" dir={direction}>
      <div className="container mt-4">
        <h2>الإحصائيات</h2>
        <iframe
          src={iframeUrl}
          frameBorder="0"
          width="100%"
          height="600"
          allowTransparency
          title="Metabase Dashboard"
        />
      </div>
    </AdminDashboardLayout>
  );
};

export default HomePageStatistics;
